<div class="container">
    <div class="row">
        <div class="col p-0">
            <app-reports-filter
                [selectedReport]="reportModel"
                [generateDisabled]="generateDisabled"
                [showClassFilter]="false"
                [instructors]="instructors"
                (doFilter)="showReport($event)"
                (generateReport)="generateReportFile($event)"
                (generateAdpExtract)="generateAdpExtract($event)">
            </app-reports-filter>
        </div>
    </div>
    <div class="row mt-3" *ngIf="reportData.length > 0">
        <div class="col p-0">
            <div class="row payroll-report-header align-items-center">
                <div class="col-5 p-0">
                    <div class="row align-items-center">
                        <div class="col-3">{{ 'PayrollReport.InstructorHeader' | translate }}</div>
                        <div class="col-3">{{ 'PayrollReport.JobCostCodeHeader' | translate }}</div>
                        <div class="col-4">{{ 'PayrollReport.CategoryNameHeader' | translate }}</div>
                        <div class="col-2">{{ 'PayrollReport.HourlyRateHeader' | translate }}</div>
                    </div>
                </div>
                <div class="col-7 p-0">
                    <div class="row align-items-center">
                        <div class="col-4">{{ 'PayrollReport.ClassNameHeader' | translate }}</div>
                        <div class="col-3">{{ 'PayrollReport.DateTimeHeader' | translate }}</div>
                        <div class="col-3 text-center">
                            {{ 'PayrollReport.ActualAndBillableTimeHeader' | translate }}
                        </div>
                        <div class="col-2 text-center">{{ 'PayrollReport.CostHeader' | translate }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-payroll-report-item *ngFor="let item of reportData" [summaryItem]="item">
                    </app-payroll-report-item>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2" *ngIf="reportData.length === 0">
        <div class="col text-center">
            <div><span class="ic-binoculars"></span></div>
            <div>{{ 'PayrollReport.NoRecords' | translate }}</div>
        </div>
    </div>
</div>
